/**
 * @module project/components/project_participate_button
 */
import React, { PropTypes } from 'react';

/**
 * Button to toggle participate form
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const ProjectParticipateButton = (props) => (
  <button
    className="btn btn-tertiary participate-button"
    onClick={props.toggleParticipateForm}
  >{props.formOpen? 'Close entry' : 'Submit entry'}</button>
);

/**
 * PropTypes.
 *
 * @property {bool} formOpen - controls if participate form is visible
 * @property {func} toggleParticipateForm - action creator to toggle participate form
 */
ProjectParticipateButton.propTypes = {
  formOpen: PropTypes.bool,
  toggleParticipateForm: PropTypes.func,
};

export default ProjectParticipateButton;
